import React from 'react';
import styled from 'styled-components';
import { Container } from '@ui';
import { FlatButton, TransparentFlatButton } from '@ui/buttons';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import SelectedDocument from './SelectedDocument';

const Wrapper = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  padding: 8px;
`;
const SelectedDocsRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;
const AddAllButtonWrapper = styled.div`
  padding: 3px 0 0 8px;

  button {
    height: 42px;
    padding: 2px 16px;
  }
`;
const RemoveAllButtonWrapper = styled.div`
  padding: 3px 0 0 8px;

  button {
    padding: 2px 16px;
  }
`;
const DocSelectionActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 16px;
`;

export const SelectedDocuments = ({
  primaryAction,
  selectedDocs,
  onSelectDocumentsClick,
  onAddAllDocs,
  onSelectedDocsChange,
  hideRemoveAllDocumentsAction,
}) => {
  const clearDocs = () => onSelectedDocsChange([]);
  const handleRemoveClick = (filenameOrFilenames) => {
    if (Array.isArray(filenameOrFilenames)) {
      onSelectedDocsChange(selectedDocs.filter((d) => !filenameOrFilenames.includes(d.filename)));
    } else {
      onSelectedDocsChange(selectedDocs.filter((d) => d.filename !== filenameOrFilenames));
    }
  };

  return (
    <div>
      {selectedDocs.length > 0 ? (
        <Wrapper>
          <Container bottom={24}>
            <SelectedDocsRowWrapper>
              {selectedDocs?.map((d) => (
                <SelectedDocument
                  key={d?.id}
                  doc={d}
                  handleRemoveClick={handleRemoveClick}
                  selectedDocs={selectedDocs}
                />
              ))}
            </SelectedDocsRowWrapper>
          </Container>
        </Wrapper>
      ) : null}
      <DocSelectionActionsWrapper>
        {!!onSelectDocumentsClick &&
          (primaryAction ? (
            <FlatButton onClick={onSelectDocumentsClick}>Select Source Documents</FlatButton>
          ) : (
            <SkeletonButton onClick={onSelectDocumentsClick}>Select Source Documents</SkeletonButton>
          ))}
        {onAddAllDocs && (
          <AddAllButtonWrapper>
            <TransparentFlatButton onClick={onAddAllDocs}>Add All</TransparentFlatButton>
          </AddAllButtonWrapper>
        )}
        {selectedDocs.length > 0 && !hideRemoveAllDocumentsAction && (
          <RemoveAllButtonWrapper>
            <TransparentFlatButton onClick={clearDocs}>Remove All</TransparentFlatButton>
          </RemoveAllButtonWrapper>
        )}
      </DocSelectionActionsWrapper>
    </div>
  );
};
